module.exports = __webpack_public_path__ + "static/media/md-undo.e2e83562.svg";